var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddressLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 29,
    viewBox: "0 0 33 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 29,
    fill: "#EBEBEB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SFE-Customer Website  \xF0\x9F\x93\x8C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-11634 -843C-11634 -844.105 -11633.1 -845 -11632 -845H8887C8888.1 -845 8889 -844.105 8889 -843V3121C8889 3122.1 8888.1 3123 8887 3123H-11632C-11633.1 3123 -11634 3122.1 -11634 3121V-843Z",
    fill: "#FBDDA3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "My Cart",
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1500,
    height: 1203,
    transform: "translate(-1327 -514)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 295",
    x: -1327,
    y: -514,
    width: 1500,
    height: 909,
    fill: "#FFF8F4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 586"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 585"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1171276196"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 282",
    x: -493.5,
    y: -15.5,
    width: 620,
    height: 167,
    rx: 17.5,
    fill: "white",
    stroke: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 482"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 167",
    x: 0.5,
    y: 0.5,
    width: 32,
    height: 28,
    rx: 5.5,
    stroke: "#FC8019"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 481"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.8182 12.6786C21.8182 11.2294 21.2579 9.83949 20.2605 8.81474C19.2632 7.78999 17.9105 7.21429 16.5 7.21429C15.0895 7.21429 13.7368 7.78999 12.7395 8.81474C11.7421 9.83949 11.1818 11.2294 11.1818 12.6786C11.1818 14.9201 12.9274 17.8417 16.5 21.3413C20.0726 17.8417 21.8182 14.9201 21.8182 12.6786ZM16.5 23C12.1663 18.9528 10 15.5115 10 12.6786C10 10.9073 10.6848 9.20858 11.9038 7.95611C13.1228 6.70363 14.7761 6 16.5 6C18.2239 6 19.8772 6.70363 21.0962 7.95611C22.3152 9.20858 23 10.9073 23 12.6786C23 15.5115 20.8337 18.9528 16.5 23Z",
    fill: "#FC8019"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.5 13.5455C16.822 13.5455 17.1309 13.4209 17.3586 13.1993C17.5864 12.9777 17.7143 12.6771 17.7143 12.3636C17.7143 12.0502 17.5864 11.7496 17.3586 11.528C17.1309 11.3063 16.822 11.1818 16.5 11.1818C16.178 11.1818 15.8691 11.3063 15.6414 11.528C15.4136 11.7496 15.2857 12.0502 15.2857 12.3636C15.2857 12.6771 15.4136 12.9777 15.6414 13.1993C15.8691 13.4209 16.178 13.5455 16.5 13.5455ZM16.5 14.7273C15.8559 14.7273 15.2382 14.4782 14.7827 14.035C14.3273 13.5917 14.0714 12.9905 14.0714 12.3636C14.0714 11.7368 14.3273 11.1356 14.7827 10.6923C15.2382 10.249 15.8559 10 16.5 10C17.1441 10 17.7618 10.249 18.2173 10.6923C18.6727 11.1356 18.9286 11.7368 18.9286 12.3636C18.9286 12.9905 18.6727 13.5917 18.2173 14.035C17.7618 14.4782 17.1441 14.7273 16.5 14.7273ZM23.0571 18.2727L25 23H19.5357V21.8182H13.4643V23H8L9.94286 18.2727H23.0571ZM21.7494 18.2727H11.2506L9.7935 21.8182H23.2065L21.7494 18.2727Z",
    fill: "#FC8019"
  }))))))), /*#__PURE__*/React.createElement("path", {
    d: "M-11632 -835H8887V-855H-11632V-835ZM8879 -843V3121H8899V-843H8879ZM8887 3113H-11632V3133H8887V3113ZM-11624 3121V-843H-11644V3121H-11624ZM-11632 3113C-11627.6 3113 -11624 3116.58 -11624 3121H-11644C-11644 3127.63 -11638.6 3133 -11632 3133V3113ZM8879 3121C8879 3116.58 8882.58 3113 8887 3113V3133C8893.63 3133 8899 3127.63 8899 3121H8879ZM8887 -835C8882.58 -835 8879 -838.581 8879 -843H8899C8899 -849.628 8893.63 -855 8887 -855V-835ZM-11632 -855C-11638.6 -855 -11644 -849.628 -11644 -843H-11624C-11624 -838.581 -11627.6 -835 -11632 -835V-855Z",
    fill: "#0091FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1500,
    height: 1203,
    fill: "white",
    transform: "translate(-1327 -514)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressLocation);
export default __webpack_public_path__ + "static/media/addressLocation.bb6bc72a6dc8f652d32f22c3d0f2d2e8.svg";
export { ForwardRef as ReactComponent };